import React from 'react';
import { Box, Typography } from '@mui/material';

export interface PageHeaderProps {
  title: string;
  eyebrow?: string;
  description?: string;
  action?: React.ReactNode;
  mb?: number;
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  eyebrow,
  description,
  action,
  mb = 3
}) => (
  <Box
    sx={{
      mb,
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: action ? 'center' : 'flex-start',
      gap: 2,
      flexWrap: 'wrap'
    }}
  >
    <Box sx={{ minWidth: 0, flex: action ? 1 : undefined }}>
      {eyebrow && (
        <Typography
          variant="label"
          color="text.secondary"
          sx={{ display: 'block', mb: 0.5 }}
        >
          {eyebrow}
        </Typography>
      )}
      <Typography
        variant="h4"
        component="h1"
        gutterBottom={false}
        noWrap
        sx={{
          fontSize: { xs: '1.25rem', md: '1.5rem' },
          fontWeight: 750,
          mb: description ? 0.5 : 0,
          overflow: 'hidden',
          textOverflow: 'ellipsis'
        }}
      >
        {title}
      </Typography>
      {description && (
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      )}
    </Box>
    {action && (
      <Box
        sx={{
          flexShrink: 0,
          maxWidth: { xs: '100%', sm: 'auto' },
          '& .MuiButton-root': { whiteSpace: 'nowrap' }
        }}
      >
        {action}
      </Box>
    )}
  </Box>
);

export default PageHeader;
